import { AppGridCreateItemButton } from "@/components/AppGrid/AppGridCreateItemButton/AppGridCreateItemButton";
import { AppGridFilter } from "@/components/AppGrid/AppGridFilter/AppGridFilter";
import { AppGridSearch } from "@/components/AppGrid/AppGridSearch/AppGridSearch";
import { AppTagFilter } from "@/components/AppGrid/AppTagFilter/AppTagFilter";
import { contactModel } from "@/models/contact";
import { getDefaultContactDirectoryEntity } from "@/models/contactDirectory";
import { Stack } from "@mantine/core";
import { colDefs } from "../colDefs";

export const Sidebar = () => {
  return (
    <Stack p="sm" h={"100%"} justify="space-between" w={"100%"}>
      <Stack>
        <AppGridCreateItemButton model={contactModel} />
        <AppGridSearch />

        <AppTagFilter
          label={"Role"}
          entity={getDefaultContactDirectoryEntity()}
          resourceProp={"jobTitleTags"}
          columnId="jobTitleIds"
        />
      </Stack>

      <AppGridFilter colDefs={colDefs} />
    </Stack>
  );
};
